import { render, staticRenderFns } from "./BridgeComplete.vue?vue&type=template&id=54cf0236&scoped=true&"
import script from "./BridgeComplete.vue?vue&type=script&lang=js&"
export * from "./BridgeComplete.vue?vue&type=script&lang=js&"
import style0 from "./BridgeComplete.vue?vue&type=style&index=0&id=54cf0236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cf0236",
  null
  
)

export default component.exports